<template>
  <section v-on:click="sectionClicked">
    <Header :class="{scrolled: isScrolled}" ref="header"
      menu="teamUpForYouth"/>
    <div class="notFoundCnt" v-if="!loadingHeader && !category">
      <div class="notFound">
        <img src="../assets/not-found.png">
        <h4>404</h4>
        <h2>Halaman tidak ditemukan</h2>
        <p>We can't find the page you looking for</p>
      </div>
    </div>
    <div class="blog" v-else>
      <div class="cnt">
        <div class="blogHeader loading" v-if="loadingHeader"></div>
        <div class="blogHeader" v-else
          :style="{'background-color': `${category.color}`}">
          <div class="blogImg" v-if="category.media"
            :style="{'background-image':
            `url(${category.media.imageMd.replace('://demoapi.', '://api.')})`}"></div>
          <div class="headerInfo">
            <h4>{{category.name}}</h4>
            <div class="backBtn" v-on:click="doBack">Kembali</div>
          </div>
        </div>
        <div class="profileCnt loading" v-if="loading"></div>
        <div class="profileCnt" v-else>
          <div class="profileItem" v-for="(item, i) in profile" :key="`profile${i}`">
            <div class="profileImg canPlay" v-if="item.media"
              :style="{'background-image': `url(${item.media.mainThumb})`}"
              v-on:click="openProfile(item)">
              <div class="playIcon"><span>Tonton video</span></div>
            </div>
            <div class="profileImg noImg" v-else v-on:click="openProfile(item)"></div>
            <h4 v-on:click="openProfile(item)">
              {{item.name}}<span v-if="item.organization">{{item.organization}}</span></h4>
            <p  v-on:click="openProfile(item)"
              v-if="item.profileShort">{{item.profileShort}}</p>
            <button v-on:click="support(item)">Dukung</button>
          </div>
        </div>
      </div>
    </div>
    <ProfileDialog ref="profileDialog"/>
    <SupportDialog ref="supportDialog"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import ProfileDialog from '@/components/ProfileDialog.vue';
import SupportDialog from '@/components/SupportDialog.vue';

export default {
  name: 'home',
  components: {
    Header,
    ProfileDialog,
    SupportDialog,
  },
  data() {
    return {
      isScrolled: false,
      viewType: 'list',
      loading: true,
      category: null,
      profile: [],
      loadingHeader: true,
    };
  },
  created() {
    document.addEventListener('scroll', this.scrolled);
  },
  destroyed() {
    document.removeEventListener('scroll', this.scrolled);
  },
  computed: {},
  methods: {
    doNothing() {},
    doBack() {
      this.$router.back();
    },
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.sectionClicked();
    },
    scrolled() {
      this.isScrolled = window.scrollY > 30;
    },
    openProfile(item) {
      this.$refs.profileDialog.open(item);
      this.$http.get(this.$config.uri(`misc/profile/${item.id}/record/play`)).then((r) => {});
    },
    support(item) {
      this.$refs.supportDialog.open(item);
      this.$http.get(this.$config.uri(`misc/profile/${item.id}/record/view`)).then((r) => {});
    },
    getData() {
      this.loading = true;
      this.$http.get(this.$config.uri(`misc/profile/all?fe=y&categoryId=${this.category.id}`)).then((r) => {
        this.profile = (r.data.status === 200) ? r.data.data : [];
        this.loading = false;
      });
    },

    /**
     * Analytic
     *
     */
    fireAlEvent(convId) {
      this.$emit('fireal', 'page_visit', 'teamup_youth_category_detail', null, convId, (r) => {
        if (r.data.status !== 200) return;
        alTimer = setTimeout(() => {
          this.fireAlEvent(r.data.id);
        }, 5000);
      });
    },
  },
  beforeDestroy() {
    if (alTimer) clearTimeout(alTimer);
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Team Up For Youth - Team Up For Impact';
    this.viewType = localStorage.getItem('viewType') || 'list';

    const { code } = this.$route.params;
    this.$http.get(this.$config.uri(`challenge/categories?code=${code}`)).then((r) => {
      this.category = (r.data.status === 200) ? r.data.data : null;
      this.loadingHeader = false;
      this.getData();
    });

    this.fireAlEvent();
  },
};
</script>

<style scoped lang="scss">
.blog{
  background-color: #fff;
}
.blogHeader{
  height: 300px;
  background-color: #5351a4;
  color: #fff;
  display: flex;
  align-items: center;
  font-family: 'GolosUIWebBold', sans-serif;
  margin-top: 120px;
  position: relative;
  box-sizing: border-box;
  padding-left: 360px;
  &.loading{
    background-color: #eee;
  }
  &.noHeader{
    height: 0px !important;
  }
  .blogImg{
    position: absolute;
    left: 40px; top: 0; bottom: 0;
    width: 240px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  .headerInfo{
    h4{
      font-size: 46px;
      margin: 0 0 6px;
    }
    .backBtn{
      position: relative;
      cursor: pointer;
      background-color: rgba(0, 0, 0, .06);
      border-radius: 50px;
      display: inline-block;
      padding: 8px 18px;
      padding-left: 48px;
      transition: all .3s ease;
      &:hover{
        background-color: rgba(0, 0, 0, .14);
      }
      &:before{
        content: "";
        position: absolute;
        left: 16px; top: 0; bottom: 0;
        width: 24px;
        background-image: url(../assets/arrow-prev.png);
        background-size: contain;
        background-position: left center;
        background-repeat: no-repeat;
      }
    }
  }
  @media (max-width: 1180px) {
    height: 26vw;
  }
  @media (max-width: 960px) {
    margin: 0 -16px;
  }
  @media (max-width: 680px) {
    height: 40vw;
  }
}

.profileCnt{
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  padding: 60px 0 0;
  margin: 0 -10px;
  @media (max-width: 680px) {
    display: block;
    margin: 0;
    padding: 30px 0 20px;
  }
  &.loading{
    background-image: url(../assets/loading.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 46px auto;
    height: 100vh;
    box-sizing: border-box;
  }
  .profileItem{
    background-color: #fff;
    width: calc(33.333333% - 20px);
    margin: 0 10px 40px;
    border-radius: 5px;
    border: #eee 1px solid;
    padding: 26px;
    box-sizing: border-box;
    position: relative;
    padding-bottom: 90px;
    transition: all .3s ease;
    &:hover{
      box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
    }
    @media (max-width: 1080px) {
      width: calc(50% - 20px);
    }
    @media (max-width: 680px) {
      width: auto;
      margin: 0 0 30px;
      border-radius: 10px;
      padding: 16px;
      padding-bottom: 86px;
    }
    .profileImg{
      height: 240px;
      border-radius: 3px;
      background-color: #ccc;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      @media (max-width: 1160px) {
        height: 180px;
      }
      @media (max-width: 1080px) {
        height: 200px;
      }
      &.noImg{
        background-image: url(../assets/image-black.png);
        background-size: 46px auto;
        opacity: .36;
      }
      &.canPlay{
        position: relative;
        cursor: pointer;
        &:before{
          content: "";
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          background-color: rgba(0, 0, 0, .46);
          border-radius: 3px;
          opacity: 0;
          transition: all .3s ease;
        }
        .playIcon{
          position: absolute;
          z-index: 3;
          width: 50px; height: 50px;
          left: 50%; top: 50%;
          margin: -32px 0 0 -25px;
          border-radius: 50%;
          background-color: #5351a4;
          background-image: url(../assets/play.png);
          background-size: 20px auto;
          background-position: 16px 50%;
          background-repeat: no-repeat;
          span{
            color: #fff;
            position: absolute;
            left: -20px; right: -20px; bottom: -20px;
            text-align: center;
            font-size: 13px;
          }
        }
        &:hover{
          &:before{
            opacity: 1;
          }
        }
      }
    }
    h4{
      margin: 10px 0 10px;
      font-size: 22px;
      font-family: 'GolosUIWebBold', sans-serif;
      line-height: 1.3;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        color: #5351a4;
      }
      @media (max-width: 1160px) {
        font-size: 20px;
      }
      span{
        display: block;
        font-size: 18px;
        @media (max-width: 1160px) {
          font-size: 16px;
        }
      }
    }
    p{
      margin: 0;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        color: #5351a4;
      }
    }
    button{
      border: none;
      font-size: 20px;
      font-family: 'GolosUIWebBold', sans-serif;
      display: block;
      position: absolute;
      left: 26px; right: 26px; bottom: 26px;
      height: 44px;
      padding: 0;
      line-height: 44px;
      border-radius: 3px;
      text-align: center;
      background-color: #5351a4;
      color: #fff;
      @media (max-width: 680px) {
        left: 16px; right: 16px;
      }
    }
  }
}

.notFoundCnt{
  position: relative;
  height: 100vh;
  .notFound{
    position: absolute;
    left: 40px; right: 40px;
    top: 50%; transform: translateY(-50%);
    margin-top: 20px;
    text-align: center;
    color: #767676;
    img{
      height: auto;
      width: 100%;
      max-width: 500px;
      margin-bottom: 40px;
    }
    h2{
      margin: 0 0 4px;
      font-size: 30px;
      line-height: 1;
    }
    h4{
      margin: 0;
      font-size: 50px;
      line-height: 1;
    }
    p{
      margin: 0;
    }
  }
}
</style>
